<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Member Management Detail</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>First Name</label>
            <input type="text" class="form-control" disabled v-model="mm.firstName" id="firstName" aria-describedby="action">
        </div>
        <div class="form-group col-3">
            <label>Last Name</label>
            <input type="text" class="form-control" disabled v-model="mm.lastName" id="lastName" aria-describedby="action">
        </div>
         <div class="form-group col-3">
            <label for="module">Email</label>
            <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module">
        </div>
        <div class="form-group col-3">
            <label>Verify By Member</label>
            <input type="checkbox" class="form-control" disabled v-model="mm.isVerifiedEmail" id="isVerifiedMember">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-3">
            <label for="module">Department</label>
            <!-- <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module"> -->
            <select type = "dropdown" class="form-control" id="module" v-model="mm.departmentName">
                <option v-for="(list, index) in this.departmentList" :key="index" :value="list.value">{{ list.title }}</option>
            </select>
        </div>
        <div v-if="this.mmRole === 'admin'" class="form-group col-3">
            <label for="role">Role</label>
            <!-- <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module"> -->
            <select type = "dropdown" class="form-control" id="role" v-model="mm.role">
                <option v-for="(list, index) in this.roleList" :key="index" :value="list.value">{{ list.title }}</option>
            </select>
        </div>
        <div class="form-group col-3">
            <label>Verify by Admin</label>
            <input type="checkbox" class="form-control" v-model="mm.isVerified" id="isVerified">
        </div>
        <div class="form-group col-3">
            <label>Active</label>
            <input type="checkbox" class="form-control" v-model="mm.isActive" id="isActive">
        </div>
    </div>

    <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable> -->
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
    <br /><br />
</div>
</template>

<script>
import api from '../../services/api'
import { memberManagement } from '../../models/memberManagement'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker
    },
    data() {
        return {
            mm: {
                ...memberManagement
            },
            mmRole: '',
            departmentList: [
                {
                    title: 'Approved Quality',
                    value: 'Approved Quality'
                },
                {
                    title: 'Request Sample',
                    value: 'Request Sample'
                }
            ],
            roleList: [
                {
                    title: 'admin',
                    value: 'admin'
                },
                {
                    title: 'user',
                    value: 'user'
                }
            ]
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const mmApi = api('member-management/detail')
            // this.mm = await mmApi.getWithParams(this.$route.query.id)

            const mmResult = await mmApi.getWithParams(this.$route.query.id)
            this.mm = mmResult[0]
            this.mmRole = mmResult[1]
        }
        console.log(this.mmRole)
    },
    methods: {
        async save() {
            const mmApi = api('member-management')
            // if(this.$route.query.id !== undefined) {
            //     await mmApi.update(this.mm, this.$route.query.id)
            // } else {
            //     await mmApi.create(this.mm)
                
            // }
            await mmApi.update(this.mm, this.$route.query.id)
            this.$router.push({ name: 'memberManagement' })
        },
        cancel() {
            this.$router.push({ name: 'memberManagement' })
        },
        finishLookup(data) {
            const currentMM = this.mm
            this.mm = {
                ...currentMM,
                ...data
            }
        }
    }
}
</script>